import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import App from "./App";
import { ColorModeContext, useMode } from "./theme";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { Toaster } from "sonner";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const Root = () => {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
          <Toaster closeButton richColors position="top-right" />
        </BrowserRouter>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

root.render(<Root />);
